import { SIZE_TYPE } from '../renderMixin'

const mainProps = {
  title: '',
  subTitle: '',
  underLine: {
    title: {
      isShow: true,
      width: '70px', // any number with px, compute(bigger than text), full(line/screen)
      color: null
    },
    subTitle: {
      isShow: false,
      width: 'full', // any number with px, compute(bigger than text), full(line/screen)
      color: null
    }
  },
  styleConfig: {
    root: null
    // title: {
    //   fontSize: '32px',
    //   color: '#000'
    // },
    // subTitle: {
    //   fontSize: '14px',
    //   color: '#666666'
    // }
  },
  hideItemMargin: false,
  size: {
    width: {
      type: SIZE_TYPE.FIXED,
      fixed: null,
      percentage: null
    },
    height: {
      type: SIZE_TYPE.AUTO,
      fixed: null,
      percentage: null
    }
  }
}

const childProps = {
  title: '',
  content: '',
  media: {
    isImage: true,
    src: '',
    coverImage: ''
  },
  clickLink: {
    isActive: false,
    url: '',
    isInnerPage: true,
    openNewWindow: false
  },
  styleConfig: {
    root: null
    // title: {
    //   fontSize: '16px',
    //   color: 'black'
    // },
    // content: {
    //   fontSize: '14px'
    // }
  }
}

export default mainProps

export { childProps }
